<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<template>
  <v-app>
    <div id="app">
      <div id="main">
        <div id="content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </v-app>
</template>


<style src="@/assets/scss/index.scss" lang="scss">
